/**
 * 로그인하지 않은 경우에만 접근 가능한 페이지
 */

import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
import GuestGuard from '@routes/guards/GuestGuard';
import { PATHS } from '@routes/paths';

//Login
const LoginPage = lazy(() => import('@pages/login'));
const KakaoOAuthPage = lazy(() => import('@pages/_o/kakao'));
const GoogleOAuthPage = lazy(() => import('@pages/_o/google'));
const NaverOAuthPage = lazy(() => import('@pages/_o/naver'));

const guestRoutes = [
  {
    element: (
      <GuestGuard>
        <Suspense>
          <Outlet />
        </Suspense>
      </GuestGuard>
    ),
    children: [
      {
        path: PATHS.login,
        element: <LoginPage />,
      },
      {
        path: PATHS.oAuth.google,
        element: <GoogleOAuthPage />,
      },
      {
        path: PATHS.oAuth.kakao,
        element: <KakaoOAuthPage />,
      },
      {
        path: PATHS.oAuth.naver,
        element: <NaverOAuthPage />,
      },
    ],
  },
];

export default guestRoutes;
